module.exports = __webpack_public_path__ + "static/media/intro-photowall-27.d0d3cb45.jpg";